import { apiRequest } from "@/lib/queryClient";
import { PlayerMessage, CoachNotification, NotificationCounts } from "@/lib/types";

// Player Messages API
export async function getPlayerMessages(params?: {
  player_id?: number;
  unread_only?: boolean;
  limit?: number;
  offset?: number;
}): Promise<PlayerMessage[]> {
  const queryParams = new URLSearchParams();
  if (params?.player_id) queryParams.append("player_id", params.player_id.toString());
  if (params?.unread_only) queryParams.append("unread_only", "true");
  if (params?.limit) queryParams.append("limit", params.limit.toString());
  if (params?.offset) queryParams.append("offset", params.offset.toString());

  const response = await apiRequest(
    "GET",
    `/api/player-messages${queryParams.toString() ? `?${queryParams.toString()}` : ""}`
  );

  if (!response.ok) {
    throw new Error("Failed to fetch player messages");
  }

  return response.json();
}

export async function markMessageAsRead(messageId: number): Promise<void> {
  const response = await apiRequest(
    "PATCH",
    `/api/player-messages/${messageId}/read`
  );

  if (!response.ok) {
    throw new Error("Failed to mark message as read");
  }
}

export async function archiveMessage(messageId: number): Promise<void> {
  const response = await apiRequest(
    "PATCH",
    `/api/player-messages/${messageId}/archive`
  );

  if (!response.ok) {
    throw new Error("Failed to archive message");
  }
}

// Coach Notifications API
export async function getNotifications(params?: {
  unread_only?: boolean;
  limit?: number;
}): Promise<CoachNotification[]> {
  const queryParams = new URLSearchParams();
  if (params?.unread_only) queryParams.append("unread_only", "true");
  if (params?.limit) queryParams.append("limit", params.limit.toString());

  const response = await apiRequest(
    "GET",
    `/api/notifications${queryParams.toString() ? `?${queryParams.toString()}` : ""}`
  );

  if (!response.ok) {
    throw new Error("Failed to fetch notifications");
  }

  return response.json();
}

export async function markNotificationAsRead(notificationId: number): Promise<void> {
  const response = await apiRequest(
    "PATCH",
    `/api/notifications/${notificationId}/read`
  );

  if (!response.ok) {
    throw new Error("Failed to mark notification as read");
  }
}

// Notification Counts API
export async function getNotificationCounts(): Promise<NotificationCounts> {
  const response = await apiRequest("GET", "/api/notifications/counts");

  if (!response.ok) {
    throw new Error("Failed to fetch notification counts");
  }

  return response.json();
}

// Batch operations
export async function markAllMessagesAsRead(): Promise<void> {
  const response = await apiRequest(
    "POST",
    "/api/player-messages/mark-all-read"
  );

  if (!response.ok) {
    throw new Error("Failed to mark all messages as read");
  }
}

export async function markAllNotificationsAsRead(): Promise<void> {
  const response = await apiRequest(
    "POST",
    "/api/notifications/mark-all-read"
  );

  if (!response.ok) {
    throw new Error("Failed to mark all notifications as read");
  }
}